import { render, staticRenderFns } from "./ProblematicAssets.vue?vue&type=template&id=678d6240&"
import script from "./ProblematicAssets.vue?vue&type=script&lang=ts&"
export * from "./ProblematicAssets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports